import './footer.scss';

import React from 'react';

const Footer = () => (
  <div style={{ backgroundColor: 'var(--primary-color)', color: '#fff', padding: '1rem', textAlign: 'center' }}>
    Družstvo NFA Invest, Fraňa Kráľa 848/28, 966 81 Žarnovica
  </div>
);

export default Footer;
